import React from "react";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { AppWrap, MotionWrap } from "../../wrapper";
import "./Skills.scss";
import { images } from "../../constants";

import GitHubCalendar from "react-github-calendar";

const education = [
  {
    year: "01/2022 - 11/2022",
    works: [
      {
        name: "Fullstack Developer ( MERN )",
        company: "Masai School",
        desc: "HTML, CSS, JS, React, Redux, Node js, Express, MongoDB",
      },
    ],
  },
  {
    year: "08/2015 - 09/2021",
    works: [
      {
        name: "B.Tech",
        company: "REVA University",
        desc: "Bachelor's degree in CSE",
      },
    ],
  },
];

const skills = [
  { name: "HTML", icon: images.html },
  { name: "CSS", icon: images.css },
  { name: "Bootstrap", icon: images.bootstrap },
  { name: "Chakra UI", icon: images.chakra },
  { name: "Javascript", icon: images.javascript },
  { name: "Python", icon: images.python },
  { name: "React", icon: images.react },
  { name: "Redux", icon: images.redux },
  { name: "MongoDB", icon: images.mongo },
  { name: "Node.js", icon: images.node },
  { name: "Express", icon: images.express },
  { name: "Git", icon: images.git },
];

const Skills = () => {
  const skillVariants = {
    view: {
      x: [-15, 0],
      opacity: [0, 1],
      transition: {
        x: {
          type: "spring",
          stiffness: "10",
        },
        duration: 0.5,
        ease: "easeInOut",
      },
    },
    hover: {
      y: -7,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
    tap: {
      y: -7,
      scale: 1.05,
      transition: {
        duration: 0.2,
        ease: "easeInOut",
      },
    },
  };
  return (
    <>
      <h2 className="head-text">
        Skills <span>&</span> Education
      </h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, index) => (
            <motion.div
              variants={skillVariants}
              whileInView="view"
              whileHover="hover"
              whileTap="tap"
              className="app__skills-item app__flex"
              key={skill.name + "-" + index}
            >
              <div className="app__flex" style={{ backgroundColor: "#edf2f8" }}>
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <motion.div className="app__skills-exp">
          {education?.map((exp) => (
            <motion.div className="app__skills-exp-item" key={exp.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{exp.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {exp?.works?.map((work) => (
                  <React.Fragment key={work.name}>
                    <motion.div
                      whileInView={{
                        opacity: [0, 1],
                        x: [-100, 5, 0],
                      }}
                      transition={{
                        duration: 1,
                      }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#313bac"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </React.Fragment>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
      <div style={{ marginTop: "5rem" }}>
        <motion.div
          variants={skillVariants}
          whileInView="view"
          whileHover="hover"
          whileTap="tap"
          className="app__skills-item app__flex"
        >
          <GitHubCalendar username="G-LalithSai" />
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
